'use client'

import { useState } from 'react'

import { FileText, RotateCcw, ShieldCheck } from 'lucide-react'

import { Button } from '@/shared/ui/Button'
import { Card, CardBody } from '@/shared/ui/Card'
import { Page } from '@/shared/ui/Page'
import { Tab, Tabs } from '@/shared/ui/Tabs'

import { AccountOverviewTab } from '../AccountOverviewTab'
import { ContentHistorySection } from '../ContentHistorySection'
import { useDataExport } from '../../hooks/useDataExport'
import { useMyData } from '../../hooks/useMyData'
import { MyDataSkeleton } from '../MyDataSkeleton'

export function MyDataPage() {
  const { record, isLoading, isError, refetch } = useMyData()
  const { requestExport, isExporting } = useDataExport(record)
  const [tab, setTab] = useState('dados')

  return (
    <Page variant="lightBlue">
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-4">
        {/* Hero */}
        <Card variant="purple">
          <CardBody className="flex flex-col gap-4">
            <div className="flex items-start gap-3">
              <span className="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                <ShieldCheck className="size-6" aria-hidden />
              </span>
              <div>
                <h1 className="text-xl font-bold text-foreground">Meus Dados</h1>
                <p className="mt-0.5 text-sm text-muted-foreground">
                  Tudo o que guardamos sobre você. Exporte quando quiser.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-3">
              <Button
                variant="primary"
                loading={isExporting}
                disabled={isExporting || !record}
                onClick={() => requestExport()}
              >
                <FileText className="size-4" />
                Exportar PDF
              </Button>
            </div>
          </CardBody>
        </Card>

        {isLoading && <MyDataSkeleton />}

        {isError && (
          <Card variant="default">
            <CardBody className="flex flex-col items-center gap-3 py-8 text-center">
              <p className="max-w-sm text-sm font-semibold text-destructive">
                Não foi possível carregar seus dados. Tente novamente.
              </p>
              <Button variant="outline" size="sm" onClick={() => refetch()}>
                <RotateCcw className="size-4" />
                Tentar novamente
              </Button>
            </CardBody>
          </Card>
        )}

        {record && (
          <>
            <Tabs value={tab} onValueChange={setTab}>
              <Tab value="dados">Meus Dados</Tab>
              <Tab value="historico">Histórico</Tab>
            </Tabs>

            {tab === 'dados' && <AccountOverviewTab record={record} />}
            {tab === 'historico' && <ContentHistorySection />}
          </>
        )}
      </div>
    </Page>
  )
}
